import './header.scss';

import React, { PropsWithChildren } from 'react';

export const Header = ({ children }: PropsWithChildren<Record<never, any>>) => {
  return <nav className="header-red">{children}</nav>;
};
